import Marquee from "react-fast-marquee";

const items = ["Cars & Coffee", "Sunrise", "Chrome", "Fresh Brew", "Good Rides", "Saturday", "Full Tank"];

export default function Ticker() {
  return (
    <div data-testid="ticker" className="border-y border-white/10 bg-background py-8">
      <Marquee speed={40} gradient={false} autoFill>
        {items.map((item) => (
          <span key={item} className="mx-8 flex items-center gap-8">
            <span className="font-serif-italic text-4xl italic text-white/25 md:text-6xl">{item}</span>
            <span className="h-2 w-2 rotate-45 bg-primary/60" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
